<ng-container *ngIf="!actions">
<td *ngIf="showProductImage">
        <a [href]="product_line.image_url" target="_blank">
            <img [src]="product_line.image_url" *ngIf="product_line.image_url" style="max-height: 90px">
        </a>
    </td>
    <td *ngIf="!hideStock">
        <span *ngIf="product_line.note"><i class="far fa-sticky-note"></i></span>
        <app-shipment-status-widget [color]="product_line.stockStatusColor()"
                                    [label]="product_line.formattedStockStatus()"
                                    [variant]="true"
                                    [showLabel]="false"></app-shipment-status-widget>
    </td>
    <td *ngIf="showStockLocation">
        {{ product_line.stock_location }}
    </td>
    <td>




        {{ product_line.number > 0 ? product_line.number :''}}</td>
    <td style="min-width: 150px" *ngIf="!hideEvents">
        <app-shipment-status-widget [status]="product_line.status" [label]="product_line.shipment_status_formatted"
                                    [showLabel]="true"></app-shipment-status-widget>
    </td>
    <td *ngIf="!hideStock">
        <ng-container *ngIf="product_line.stock_updated && product_line.stock_updated.isValid()">
        <span class="text-nowrap">
        {{product_line.stock}} ({{product_line.stock_reserved}})
        </span>
            <br/>
            <small class="text-muted text-monospace text-nowrap">
                {{product_line.stock_updated.format('DD.MM.YYYY HH:mm')}}
            </small>
        </ng-container>
    </td>
    <td style="min-width: 150px" *ngIf="!hidePo">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control  form-control-sm" name="shipment-product-lines-{{i}}-purchase_order"
                   [(ngModel)]="product_line.purchase_order" (ngModelChange)="productLineStatusChange(product_line)">
            <span class="input-group-text" *ngIf="shipment?.branch && product_line.purchase_order">
                                                <a [href]="poUrl()" target="_blank"><i class="fas fa-link"></i></a>
                                </span>
        </div>
    </td>
    <td style="min-width: 150px" *ngIf="!hideNotes">

<span (click)="editNote = !editNote" *ngIf="!editNote">
    <div [innerHTML]="product_line.note | newlineToBr"></div>
    <span *ngIf="!product_line.note"> - </span>
</span>
        <textarea type="text" class="form-control  form-control-sm" name="shipment-product-lines-{{i}}-note" *ngIf="editNote"
                  [(ngModel)]="product_line.note" (ngModelChange)="productLineStatusChange(product_line)"
                  (input)="adjustTextareaHeight($event)"

        ></textarea>
        <small class="text-muted">
            {{ product_line.note_modified && product_line.note_modified.isValid() ? 'Modified: ' + product_line.note_modified.format('DD-MM-YYYY HH:mm') : '' }}
        </small>
    </td>
    <td style="width: 15%">
        <ng-container *ngIf="!inlineEdit">
            {{ product_line.product_number }}
        </ng-container>
        <div class="input-group input-group-sm" *ngIf="inlineEdit">
            <input type="text" class="form-control  form-control-sm" name="shipment-product-lines-{{i}}-product_number"
                   [(ngModel)]="product_line.product_number">
        </div>

        <br/>
        <ng-container *ngIf="product_line.product_number_ean">
        <code class="d-block" *ngFor="let ean of product_line.product_number_ean.split(',')">{{ean}}</code>
        </ng-container>
    </td>
    <td style="width: 40%">

        <ng-container *ngIf="!inlineEdit">
        {{ product_line.product_text_1 }}
        </ng-container>

        <div class="input-group input-group-sm" *ngIf="inlineEdit">
            <input type="text" class="form-control  form-control-sm" name="shipment-product-lines-{{i}}-product_text_1"
                   [(ngModel)]="product_line.product_text_1" (ngModelChange)="productLineStatusChange(product_line)">
        </div>

        <ng-container *ngIf="product_line.product_text_2"><br/> {{ product_line.product_text_2 }}</ng-container>
        <ng-container *ngIf="product_line.product_text_3"><br/> {{ product_line.product_text_3 }}</ng-container>
        <ng-container *ngIf="product_line.packaging_code"><br/> <span
                class="badge text-bg-primary rounded-pill">{{product_line.packaging_code}}</span></ng-container>

        <div class="d-flex align-items-center gap-1">
            <ng-container *ngIf="product_line.status">
                <app-shipment-status-widget [status]="product_line.status"
                                            [label]="product_line.shipment_status_formatted"
                                            [asBadge]="true"></app-shipment-status-widget>
            </ng-container>


            <app-dg-badges [productLine]="product_line"></app-dg-badges>
        </div>

        <div *ngIf="product_line.child_product_lines">
            <ul>
                <li *ngFor="let child_product_line of product_line.child_product_lines">{{ child_product_line.product_text_1 }} ({{child_product_line.product_number}})</li>
            </ul>
        </div>
    </td>
    <td class="text-end text-nowrap" *ngIf="!hideAmount">

        <div class="d-flex flex-column align-items-end">

        <span *ngIf="!inlineEdit">{{ product_line.amount + ' ' + (product_line.unit ? product_line.unit : 'stk.') }}</span>
            <div class="input-group input-group-sm flex-nowrap" *ngIf="inlineEdit">
                <input type="text" class="form-control  form-control-sm" name="shipment-product-lines-{{i}}-amount" style="min-width: 5rem"
                       (click)="setStopBlur($event)"
                       (blur)="setStartBlur($event)"
                       [(ngModel)]="product_line.amount" (ngModelChange)="productLineStatusChange(product_line)">
                                <span class="input-group-text">
                                             {{product_line.unit?product_line.unit:'stk' }}
                                </span>
            </div>

            <span *ngIf="shipment.is_internal_shipment && product_line.original_amount!= product_line.amount" class="text-decoration-line-through">{{product_line.original_amount}} {{product_line.unit?product_line.unit:'stk' }}</span>
        </div>
    </td>
    <td class="text-end text-nowrap" *ngIf="!hideWeight">
        <div class="d-flex flex-column align-items-end">

            <span *ngIf="!inlineEdit">{{ product_line?.weight ? product_line.weight : '-' }} kg</span>
            <span>(LxBxH) {{ product_line.length }}x{{ product_line.width }}x{{ product_line.height }}
                m</span>
            <div class="input-group input-group-sm flex-nowrap" *ngIf="inlineEdit">
                <input type="text" class="form-control  form-control-sm" name="shipment-product-lines-{{i}}-weight"
                       style="min-width: 5rem"
                       [(ngModel)]="product_line.weight" (ngModelChange)="productLineStatusChange(product_line)">
                <span class="input-group-text">kg</span>
            </div>
            <span class="badge text-bg-danger rounded-pill" *ngIf="!product_line.weight">INGEN VÆGT</span>
            <button class="btn btn-sm btn-secondary" *ngIf="!inlineEdit" (click)="openEditShipmentProductLineModal()"
                    id="ppp-{{product_line.id}}">Edit
            </button>
        </div>
    </td>
    <td class="text-end text-nowrap"
        *ngIf="showNumberPicked">

        <ng-container *ngIf="product_line.amount_picked + product_line.amount_scanned > product_line.amount">
            Ny Total:

            <span class="h3">
                    {{ product_line.amount_picked + product_line.amount_scanned }} {{ product_line.unit ? product_line.unit : 'stk.' }}
            </span>
            <br>
        </ng-container>

        Plukket:
        <span class="h3">
        {{ product_line.amount_picked ? product_line.amount_picked + ' ' + (product_line.unit ? product_line.unit : 'stk.') : '-' }}
        </span>
        <br>
        Scannet:
        <span class="h3">
        {{ product_line.amount_scanned ? product_line.amount_scanned + ' ' + (product_line.unit ? product_line.unit : 'stk.') : '-' }}
        </span>



    </td>
    <td class="text-end text-nowrap" *ngIf="showNumberPicked">
        <span class="badge rounded-pill bg-secondary" *ngIf="product_line.product_type">{{product_line.product_type}}</span>
        <div class="d-flex flex-column gap-1">
        <span class="h3">
            <i class="fas fa-ban text-danger" *ngIf="product_line.amount !== product_line.amount_picked + product_line.amount_scanned"></i>
            <i class="fas fa-check-square text-success" *ngIf="product_line.amount === product_line.amount_picked + product_line.amount_scanned"></i>
        </span>
            <ng-container *ngIf="
            product_line.product_type !== 'set' &&
            product_line.status !=='pending_remote' && product_line.status !=='shipped_remote'
            ">
            <span style="display: inline-block"></span>
            <ng-container *ngIf="product_line.amount > 0">
                <div *ngIf="(product_line.amount_scanned > 4 || showManualInput)">
                <input type="number" class="form-control form-control-sm" name="shipment-product-lines-{{i}}-amount_scanned" min="0" max="{{ product_line.amount - product_line.amount_picked }}"
                     [ngModel]="product_line.amount_scanned"
                       (ngModelChange)="manualScanChanged($event)"
                       (click)="setStopBlur($event)"
                       (blur)="setStartBlur($event)"
                >
                </div>
                <a href="javascript:0"
                   (click)="setPickStatus(product_line.amount - product_line.amount_picked)"
                   *ngIf="permissionsService?.permissions?.ScanAll || ((product_line.amount_scanned >= 5 ) &&
                   product_line.amount !== product_line.amount_picked
                    && product_line.amount_scanned !== (product_line.amount - product_line.amount_picked))">Scan alle</a>

                <a href="javascript:0" (click)="product_line.amount_scanned = null;setPickStatus(0)"
                   *ngIf="product_line.amount_scanned">Fortryd scan</a>

            </ng-container>
            </ng-container>
        </div>
    </td>

</ng-container>
<ng-container *ngIf="actions">

    <td colspan="500">
        <div class="d-flex" style="gap: 0.25rem">

        <!-- @todo quick actions-->
        <button (click)="quickAction('ordered')" class="btn btn-success btn-sm">Bestilt</button>
        <button (click)="quickAction('arrived')" class="btn btn-success btn-sm">Hjemkommet</button>
            <button (click)="quickActionShipment('shipment_modified', {delete_shipment_product_line_id:product_line.id})"
                    class="btn btn-success btn-sm">Delete
            </button>
            <button (click)="startCreateNewEvent()" class="btn btn-sm btn-success" i18n>New event</button>
       <!-- <button (click)="flashProductLine()" class="btn btn-sm btn-success" i18n>Flash Product Line</button> -->
        </div>
    </td>
</ng-container>
